import {
  Cloneable,
  DBStatus,
  ExportPaieType,
  HorariusTimeZone,
  PayCompilationType,
  PayPeriodType,
  ScheduleType,
  TimesheetType
} from "./common.model";
import * as moment from "moment";

import {Utils} from "./Utils";

export class Enterprise extends Cloneable{
  id: number;
  entityCode: string;
  enterpriseCode: string;
  name: string;
  payPeriodRef: Date;
  systemType: ExportPaieType;
  payPeriodType: PayPeriodType;
  workedHour: DBStatus;
  workedHourCode: string;
  training: DBStatus;
  trainingCode: string;
  traineeship: DBStatus;
  /**
   HORARIUS Stupid shit, traineeship (Formation) is actually training (Entrainement).
   This is the way it's saved in the db...
   We keeping it that way to have the java UI still working.
   */
  traineeshipCode: string;
  holiday: DBStatus;
  holidayCode: string;
  vacations: DBStatus;
  vacationsCode: string;
  sickLeave: DBStatus;
  sickLeaveCode: string;
  paidLeave: DBStatus;
  paidLeaveCode: string;
  paidAbsence: DBStatus;
  paidAbsenceCode: string;



  timeBank: DBStatus;
  timeBankUsedCode: string;
  timeBankAddCode: string;
  payBacktime: number;

  compilation: PayCompilationType;
  daysToDeposit: number;
  // timezone: string;
  timezone: HorariusTimeZone;
  country: string;
  state: string;
  allowAntic: DBStatus;
  allowAutoTimesheetValue: DBStatus;
  allowPayStub: DBStatus;

  apiUserName: string;
  apiPassword: string;
  apiTestMode: boolean;
  apiEnterpriseCode: string;
  active:boolean;
  willBeDeactivatedOnDate: Date;

  unionRelated: DBStatus;
  unionRelatedCode: string;
  otherType: DBStatus;
  otherTypeCode: string;
  zohoId: string;
  paidFamilyAbsence: DBStatus;
  paidFamilyAbsenceCode: string;

  firstDayCSST: DBStatus;
  firstDayCSSTCode: string;

  vacationsAreInMinutes = false;
  usesJobSegment = false;

  usesAllieRH = false;
  allieRHApiClientId: string;
  allieRHApiSecret: string;
  allieRHApiKey: string;
  readJobIdFromCustomFields = false;
  jobIdCustomFieldName: string;
  verifyAllieRHCompanyNumber = false;

  nbSegmentUsed: number;
  segment1Label: string;
  segment2Label: string;
  segment3Label: string;
  segment4Label: string;
  segment5Label: string;
  segment6Label: string;
  zohoName: string;
  noteSysAdmin: string;

  useBirthDateFromAPI = true;
  useAddressFromAPI = true;

  toBeDeleted = false;
  scheduledToBeDeletedAfterDate : Date;
  paramsProfileIsMandatoryWhenImportingFromAPI = false;
//  useCgiAPIV2 = false;
  cgiBusinessId = '';

  useCgiAPIV2WithConsent = false;
  useCgiAPIV2WithoutConsent = false;
  cgiAPIV2ClientId = '';
  cgiAPIV2ClientSecret = '';
  cgiAPIV2TestMode = false;


  usesOdoo = false;
  odooHost = '';
  odooDatabase = '';
  odooUsername = '';
  odooPasswordOrAPIKey = '';
  verifyOdooCompanyNumber = false;
  odooCompanyNumber='';
  odooCodeForTsType='';
  blockTextMemoBetweenEmployee = false;
  overnightTSAccountedOnEndDate = false;
  summaryAreUsingTheTSDateAndNotTheStartOfTheWeek = false;
  calculateStatutoryHolidayWithoutSummary = false;

  usesSageIntacct = false;
  sageIntacctUsername = '';
  sageIntacctCompanyId = '';
  sageIntacctEntityId = '';


  _createSpecialElement(propertyName: string, data: any) {
    if ('payPeriodRef' === propertyName){
      this.payPeriodRef = moment(data).toDate();
      return true;
    }
    if ('systemType' === propertyName) {
      this.systemType = ExportPaieType.retrieveFromJavaCode(data);
      return true;
    }
    if ('payPeriodType' === propertyName) {
      this.payPeriodType = PayPeriodType.retrieveFromCode(data);
      return true;
    }
    if ('workedHour' === propertyName) {
      this.workedHour = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('training' === propertyName) {
      this.training = DBStatus.retrieveFromCode(data);
      return true;
    }

    if ('traineeship' === propertyName) {
      this.traineeship = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('holiday' === propertyName) {
      this.holiday = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('vacations' === propertyName) {
      this.vacations = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('sickLeave' === propertyName) {
      this.sickLeave = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('paidLeave' === propertyName) {
      this.paidLeave = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('paidAbsence' === propertyName) {
      this.paidAbsence = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('timeBank' === propertyName) {
      this.timeBank = DBStatus.retrieveFromCode(data);
      return true;
    }

    if ('compilation' === propertyName) {
      this.compilation = PayCompilationType.retrieveFromCode(data);
      return true;
    }

    if ('allowAntic' === propertyName) {
      this.allowAntic = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('allowAutoTimesheetValue' === propertyName) {
      this.allowAutoTimesheetValue = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('allowPayStub' === propertyName) {
      this.allowPayStub = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('timezone' === propertyName) {
      this.timezone = HorariusTimeZone.retrieveFromCode(data);
      return true;
    }

    if ('unionRelated' === propertyName) {
      this.unionRelated = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('otherType' === propertyName) {
      this.otherType = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('paidFamilyAbsence' === propertyName) {
      this.paidFamilyAbsence = DBStatus.retrieveFromCode(data);
      return true;
    }

    if ('firstDayCSST' === propertyName) {
      this.firstDayCSST = DBStatus.retrieveFromCode(data);
      return true;
    }

    return false;
  }

  public retrieveFirstDateOfPayOfTheYearFor(stop: Date): Date{
    const toReach = moment(stop);
    let refererence = moment(this.payPeriodRef);
    // while (refererence.isBefore(toReach,'second')){
    // refererence.add(52,'weeks');
    // }
    let period = 1;

    if (PayPeriodType.TWO_WEEK === this.payPeriodType){
      // refererence.add(-144,'weeks');
      while (true) {
        const tmp = moment(refererence);
        tmp.add(13,'days') ;
        if (tmp.year() === toReach.year()){
          break;
        }
        refererence.add(2,'weeks');
      }

      while (refererence.isBefore(toReach,'second')) {
        refererence.add(2,'weeks');
        period++;
      }
      refererence.add(-2,'weeks');
      period--;

    }else if (PayPeriodType.WEEKLY === this.payPeriodType){
      // refererence.add(-145,'weeks');
      while (true) {
        const tmp = moment(refererence);
        tmp.add(6,'days') ;
        if (tmp.year() === toReach.year()){
          break;
        }
        refererence.add(1,'weeks');
      }

      while (refererence.isBefore(toReach,'second')) {
        refererence.add(1,'weeks');
        period++;
      }
      refererence.add(-1,'weeks');
      period--;

    }
    if (period===0){
      period = 52;
    }
    return refererence.toDate();

  }

  public canExportTimeBank(){
    if (DBStatus.ACTIVE === this.timeBank){
      if (!Utils.isNullOrUndefined(this.timeBankAddCode)){
        if (!Utils.isNullOrUndefined(this.timeBankUsedCode)){
          if (this.timeBankAddCode.length>0){
            if (this.timeBankUsedCode.length>0){
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  public getPeriodWithDate(date:Date):number{

    if (PayPeriodType.TWO_WEEK === this.payPeriodType){
      return this.getPeriod(moment(date).add(13,'day').toDate(),2,this.payBacktime,this.daysToDeposit);
    }else{
      return this.getPeriod(moment(date).add(6,'day').toDate(),1,this.payBacktime,this.daysToDeposit);
    }

  }

  public getPeriod(date: Date, nbWeeksPerPeriod: number, payBackTime: number, daysToDeposit: number):number{
    // console.log('GetPeriod ' + moment(date).format('LLL'))
    const dt = moment(date).add(daysToDeposit + 7*payBackTime,'day');
    const year = dt.year();
    // console.log('GetPeriod2 ' + moment(dt).format('LLL'))
    do {
      dt.add(-nbWeeksPerPeriod,'week');
    } while (year === dt.year());

    // dt.add()
    //
    // Calendar c = Calendar.getInstance();
    // c.setTime(date);
    // c.add(Calendar.DAY_OF_YEAR, daysToDeposit + (7 * payBackTime));
    // date = c.getTime();
    // int year = c.get(Calendar.YEAR);
    // do {
    //   c.add(Calendar.WEEK_OF_YEAR, -weekPerPeriod);
    // } while (year == c.get(Calendar.YEAR));
    dt.add(nbWeeksPerPeriod,'week');
    let period = 1;
    do{
      period++;
      dt.add(nbWeeksPerPeriod,'week');
    }while (dt.isBefore(moment(date)));

    // - Jerome I removed the following lines.
    // dt.add(-nbWeeksPerPeriod,'week');
    // period--;
    return period;

  }



  public retrievePeriod(type: PayPeriodType, payPeriodRef:Date, stop: Date): any{
    const toReach = moment(stop);
    let refererence = moment(payPeriodRef);
    // while (refererence.isBefore(toReach,'second')){
    // refererence.add(52,'weeks');
    // }
    let period = 1;

    if (PayPeriodType.TWO_WEEK === type){
      // refererence.add(-144,'weeks');
      while (true) {
        const tmp = moment(refererence);
        tmp.add(13,'days') ;
        if (tmp.year() === toReach.year()){
          break;
        }
        refererence.add(2,'weeks');
      }

      while (refererence.isBefore(toReach,'second')) {
        refererence.add(2,'weeks');
        period++;
      }
      refererence.add(-2,'weeks');
      period--;

    }else if (PayPeriodType.WEEKLY === type){
      // refererence.add(-145,'weeks');
      while (true) {
        const tmp = moment(refererence);
        tmp.add(6,'days') ;
        if (tmp.year() === toReach.year()){
          break;
        }
        refererence.add(1,'weeks');
      }

      while (refererence.isBefore(toReach,'second')) {
        refererence.add(1,'weeks');
        period++;
      }
      refererence.add(-1,'weeks');
      period--;

    }
    if (period===0){
      period = 52;
    }
    return {firstDate: refererence.toDate(),period: period};
    // return refererence.toDate();

  }


  public retrieveEndOfPeriodIfStartIs(startPeriod: Date): Date{

    let res = moment(startPeriod).add(6, 'day'); // WEEKLY
    switch(this.payPeriodType){
      case PayPeriodType.TWO_WEEK:
        res = moment(startPeriod).add(13, 'day'); // WEEKLY
    }
    return res.toDate();
  }


  paySystemHasWebAPI(): boolean{
    switch(this.systemType){
      case ExportPaieType.DESJARDINS:
        return true;
      case ExportPaieType.DESJARDINS_SPLIT:
        return true;
      case ExportPaieType.NETHRIS:
        return true;
      case ExportPaieType.NETHRIS_SPLIT:
        return true;
    }
    return false;
  }

  folksAvailable():boolean{
    return this.usesAllieRH;
  }

  folksConfigured():boolean{
    if (this.usesAllieRH){
      if (!Utils.isEmpty(this.allieRHApiClientId)){
        return true;
      }
    }
    return false;
  }


  odooConfigured():boolean{
    if (this.usesOdoo){
      if (!Utils.isEmpty(this.odooHost)){
        if (!Utils.isEmpty(this.odooDatabase)){
          if (!Utils.isEmpty(this.odooUsername)){
            if (!Utils.isEmpty(this.odooPasswordOrAPIKey)){
              return true;
            }
            return true;
          }
        }
      }
    }
    return false;
  }


  sageIntacctConfigured():boolean{
    if (this.usesSageIntacct){
      if (!Utils.isEmpty(this.sageIntacctUsername)){
              return true;
      }
    }
    return false;
  }

  apiAvailable():boolean{
    return this.paySystemHasWebAPI();
  }

  apiConfigured():boolean{
    if (this.paySystemHasWebAPI()){
      if (!Utils.isNullOrUndefined(this.apiEnterpriseCode)){
        if (!Utils.isNullOrUndefined(this.apiUserName)){
          if (!Utils.isNullOrUndefined(this.apiPassword)){
            return true;
          }
        }
      }
      if (this.useCgiAPIV2){
        if (!Utils.isNullOrUndefined(this.cgiBusinessId)){
          return true;
        }
      }

    }
    return false;
  }

  public get useCgiAPIV2(){
    if (this.useCgiAPIV2WithConsent || this.useCgiAPIV2WithoutConsent){
      return true;
    }
    return false;
  }

  public retrieveTimesheetTypeAvailable(includeBankTypes: boolean): TimesheetType[]{
    let res = new Array<TimesheetType>();
    let orig = TimesheetType.ALL_NO_BANK_TYPE;
    if (includeBankTypes){
      orig = TimesheetType.ALL;
    }
    if (ExportPaieType.SAGES === this.systemType){
      return orig;
    }
    if (ExportPaieType.MAGIKPAY === this.systemType){
      return orig;
    }
    if (ExportPaieType.ROCHELEAU === this.systemType){
      return orig;
    }
    if (ExportPaieType.SCQC === this.systemType){
      return orig;
    }


    for (const tt of orig){
      switch (tt){
        case TimesheetType.TRAVAIL:
          if (DBStatus.ACTIVE === this.workedHour){
            res.push(tt);
          }
          break;
        case TimesheetType.ENTRAINEMENT:
          if (DBStatus.ACTIVE === this.traineeship){
            res.push(tt);
          }
          break;
        case TimesheetType.FORMATION:
          if (DBStatus.ACTIVE === this.training){
            res.push(tt);
          }
          break;
        case TimesheetType.FERIE:
          if (DBStatus.ACTIVE === this.holiday){
            res.push(tt);
          }
          break;
        case TimesheetType.VACANCE:
          if (DBStatus.ACTIVE === this.vacations){
            res.push(tt);
          }
          break;
        case TimesheetType.CONGE_AVEC_SOLDE:
          // if ((DBStatus.ACTIVE === this.paidLeave) || (DBStatus.ACTIVE===this.paidAbsence)){
          if ((DBStatus.ACTIVE===this.paidAbsence)){
            res.push(tt);
          }
          break;
        case TimesheetType.ABSAUTHPAYE:
          // if ((DBStatus.ACTIVE === this.paidLeave) || (DBStatus.ACTIVE===this.paidAbsence)){
          if ((DBStatus.ACTIVE === this.paidLeave)){
            res.push(tt);
          }
          break;
        case TimesheetType.ABSDECPAYE:
          if ((DBStatus.ACTIVE === this.paidLeave)){
            res.push(tt);
          }
          break;
        case TimesheetType.ABSMALPAYE:
          if (DBStatus.ACTIVE === this.sickLeave){
            res.push(tt);
          }
          break;
        case TimesheetType.ABSFAM_PAID:
          if (DBStatus.ACTIVE === this.paidFamilyAbsence){
            res.push(tt);
          }
          break;
        case TimesheetType.OTHER:
          if (DBStatus.ACTIVE === this.otherType){
            res.push(tt);
          }
          break;
        case TimesheetType.UNION_RELATED:
          if (DBStatus.ACTIVE === this.unionRelated){
            res.push(tt);
          }
          break;
        case TimesheetType.JOUR1CSST:
          if (DBStatus.ACTIVE === this.firstDayCSST){
            res.push(tt);
          }
          break;

        default:
          res.push(tt);
          break;
      }
    }


    return res;



    // if (this.session.useBankType() || this.session.canManageBanks){
    //   console.log('User can use of manage BankType')
    //   this.timesheetTypes = TimesheetType.sort(this.translate,TimesheetType.ALL);
    // }else{
    //   console.log('No BankType')
    //   this.timesheetTypes = TimesheetType.sort(this.translate,TimesheetType.ALL_NO_BANK_TYPE);
    // }

  }

  public retrieveScheduleTypeAvailable(includeBankTypes: boolean, includeVacation: boolean,
                                       includePaidSickDays?:boolean, includePaidFamilyDays?:boolean,
                                       includeUnPaidSickDays?:boolean, includeUnPaidFamilyDays?:boolean): ScheduleType[]{
    let res = new Array<ScheduleType>();
    let orig = ScheduleType.ALL_NO_VACATION_AND_NO_BANK;
    console.log('includeBankType: ' + includeBankTypes + ' includeVacation: ' + includeVacation);
    if (includeBankTypes && includeVacation){
      console.log('ALL');
      orig = ScheduleType.ALL;
    }
    if (includeBankTypes && !includeVacation){
      console.log('NO_VACATION');
      orig = ScheduleType.ALL_NO_VACATION;
    }
    if (!includeBankTypes && includeVacation){
      console.log('NO_BANK');
      orig = ScheduleType.ALL_NO_BANK;
    }
    if (ExportPaieType.SAGES === this.systemType){
      return orig;
    }
    if (ExportPaieType.MAGIKPAY === this.systemType){
      return orig;
    }
    if (ExportPaieType.ROCHELEAU === this.systemType){
      return orig;
    }
    if (ExportPaieType.SCQC === this.systemType){
      return orig;
    }


    for (const tt of orig){
      switch (tt){
        case ScheduleType.TRAVAIL:
          if (DBStatus.ACTIVE === this.workedHour){
            res.push(tt);
          }
          break;
        case ScheduleType.ENTRAINEMENT:
          if (DBStatus.ACTIVE === this.traineeship){
            res.push(tt);
          }
          break;
        case ScheduleType.FORMATION:
          if (DBStatus.ACTIVE === this.training){
            res.push(tt);
          }
          break;
        case ScheduleType.FERIE:
          if (DBStatus.ACTIVE === this.holiday){
            res.push(tt);
          }
          break;
        case ScheduleType.VACANCE:
          if (DBStatus.ACTIVE === this.vacations){
            if (includeVacation){
              res.push(tt);
            }
          }
          break;
        case ScheduleType.CONGE_AVEC_SOLDE:
          if ((DBStatus.ACTIVE===this.paidAbsence)){
            res.push(tt);
          }
          break;
        case ScheduleType.SICK_LEAVE_PAID:
          if (includePaidSickDays){
            res.push(tt);
          }
          break;
        case ScheduleType.SICK_LEAVE_UNPAID:
          if (includeUnPaidSickDays){
            res.push(tt);
          }
          break;
        case ScheduleType.FAMILY_LEAVE_PAID:
          if (includePaidFamilyDays){
            res.push(tt);
          }
          break;
        case ScheduleType.FAMILY_LEAVE_UNPAID:
          if (includeUnPaidFamilyDays){
            res.push(tt);
          }
          break;
        case ScheduleType.BEREAVEMENT_LEAVE_PAID:
          if ((DBStatus.ACTIVE===this.paidLeave)){
            res.push(tt);
          }
          break;

        default:
          console.log('Adding default',tt);
          res.push(tt);
          break;
      }

    }


    return res;



    // if (this.session.useBankType() || this.session.canManageBanks){
    //   console.log('User can use of manage BankType')
    //   this.timesheetTypes = TimesheetType.sort(this.translate,TimesheetType.ALL);
    // }else{
    //   console.log('No BankType')
    //   this.timesheetTypes = TimesheetType.sort(this.translate,TimesheetType.ALL_NO_BANK_TYPE);
    // }

  }

  public canDeleteEnterprise(){
    let res = false;
    if (this.active===false){
      if (this.toBeDeleted===true){
        if (this.scheduledToBeDeletedAfterDate){
          // console.log(this.enterpriseCode)
          // console.log('isBeforeToday ' + Utils.isBeforeToday(this.scheduledToBeDeletedAfterDate));
          // console.log('isToday ' + Utils.isToday(this.scheduledToBeDeletedAfterDate));
          //
          if (Utils.isBeforeToday(this.scheduledToBeDeletedAfterDate) || Utils.isToday(this.scheduledToBeDeletedAfterDate)){
            res = true;
          }
        }
      }
    }

    return res;

  }


}
